module.exports = __webpack_public_path__ + "assets/img/6ca6e136c4e74ed5501efa57a37716a9.png";